
const contents = "query NetworkTopicSettingsClients {\n  settings {\n    network {\n      ...NetworkTopicSettingsFields\n    }\n    copilot {\n      viewerCanAccessAIAssistedAnswers\n    }\n  }\n}\n\nfragment NetworkTopicSettingsFields on NetworkSettings {\n  isOfficeTopicsEnabled\n  networkTopicsState\n}";
const sha256Hash = "14543bcd3f500d7c6f65d9727c4c5910108c6f2e9093cda1523c49277ac1966d";
export default { contents: contents, sha256Hash: sha256Hash };
